import { actionType } from "../utils/helpers/generalHelper";
import * as FaqConstants from "../constants/faq.constant";
import FaqService from "../services/faq.service";
import ErrorHelper from "../utils/helpers/errorHelper";
import { toast } from "react-hot-toast";

export const createNewFaq = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(FaqConstants.CREATE_FAQ_REQUEST));
    const data = await FaqService.create(payload);
    if (data.status !== 201) {
      throw data;
    }
    const responseData = data.data;
    dispatch(actionType(FaqConstants.CREATE_FAQ_SUCCESS, responseData));
    dispatch(fetchFaqs());
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(FaqConstants.CREATE_FAQ_FAILURE));
    toast.error(message);
  }
};

export const fetchFaqs = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(FaqConstants.FETCH_ALL_FAQ_REQUEST));
    const data = await FaqService.fetchAll(payload);
    console.log({ data });
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(actionType(FaqConstants.FETCH_ALL_FAQ_SUCCESS, responseData));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(FaqConstants.FETCH_ALL_FAQ_FAILURE));
    toast.error(message);
  }
};

export const deleteFaq = (payload) => async (dispatch) => {
  const { id, action } = payload;
  try {
    dispatch(
      actionType(FaqConstants.DELETE_FAQ_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await FaqService.delete(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(FaqConstants.DELETE_FAQ_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`FAQ ${action}d successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(FaqConstants.DELETE_FAQ_FAILURE), {
      loading: false,
      id,
    });
    toast.error(message);
  }
};

export const setStatus = (payload) => async (dispatch) => {
  const { id, action } = payload;
  try {
    dispatch(
      actionType(FaqConstants.ACTIVATE_OR_DEACTIVATE_FAQ_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await FaqService.approveOrDisapprove(payload);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(FaqConstants.ACTIVATE_OR_DEACTIVATE_FAQ_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`Faq ${action}d successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(FaqConstants.ACTIVATE_OR_DEACTIVATE_FAQ_FAILURE), {
      loading: false,
      id,
    });
    toast.error(message);
  }
};

export const updateFaq = (id, payload) => async (dispatch) => {
  try {
    dispatch(
      actionType(FaqConstants.UPDATE_FAQ_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await FaqService.update(id, payload);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(FaqConstants.UPDATE_FAQ_SUCCESS, {
        loading: false,
        id,
      })
    );
    dispatch(fetchFaqs());
    toast.success(`FAQ updated successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(FaqConstants.UPDATE_FAQ_FAILURE), {
      loading: false,
      id,
    });
    toast.error(message);
  }
};
